import React from "react";
import { NavLink } from "react-router-dom";
import "./MobileBottomNav.css";

function IconLeagues({ isActive }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth={isActive ? "0" : "2"} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
      <path d="M4 22h16"/>
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
    </svg>
  );
}

function IconMatches({ isActive }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth={isActive ? "0" : "2"} strokeLinecap="round" strokeLinejoin="round">
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
      <line x1="16" x2="16" y1="2" y2="6"/>
      <line x1="8" x2="8" y1="2" y2="6"/>
      <line x1="3" x2="21" y1="10" y2="10"/>
      {isActive && (
        <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" stroke="white" strokeWidth="3"/>
      )}
    </svg>
  );
}

function IconHome({ isActive }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth={isActive ? "0" : "2"} strokeLinecap="round" strokeLinejoin="round">
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );
}

function IconShield({ isActive }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth={isActive ? "0" : "2"} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
      <line x1="12" x2="12" y1="8" y2="12" stroke={isActive ? "white" : "currentColor"}/>
      <line x1="12" x2="12.01" y1="16" y2="16" stroke={isActive ? "white" : "currentColor"}/>
    </svg>
  );
}

function IconAccount({ isActive }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth={isActive ? "0" : "2"} strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  );
}

const tabs = [
  { to: "/ligas", label: "Ligas", Icon: IconLeagues },
  { to: "/partidos", label: "Partidos", Icon: IconMatches },
  { to: "/", label: "Inicio", Icon: IconHome },
  { to: "/suspensiones", label: "Suspensiones", Icon: IconShield },
  { to: "/mis-equipos", label: "Mi cuenta", Icon: IconAccount },
];

export default function MobileBottomNav() {
  return (
    <nav className="mobile-bottom-nav" aria-label="Navegación principal">
      {tabs.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) =>
            `mbn-link${isActive ? " active" : ""}`
          }
        >
          {({ isActive }) => (
            <>
              <span className="mbn-icon" aria-hidden="true">
                <Icon isActive={isActive} />
              </span>
              <span className="mbn-label">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

